import { render } from "./education.vue?vue&type=template&id=6cb5e32a"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"
script.render = render

export default script